export default "/images/qr_apk.png?9b9ac7d1efa93df438c8a94751f0e92a";